<div class="col-md-12 mb-30" [hidden]="Selected_ProductRequest_Record.id>0 || FormTypeShow!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات درخواست کالا</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام کالا</label>
          <input [(ngModel)]="Filter_Product" name="Filter_Product" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> وضیعت </label>
          <select [(ngModel)]="Filter_Status" name="Filter_Status" class="custom-select">
            <option value="0">همه موارد</option>
            <option value="1">در حال بررسی</option>
            <option value="2">عدم تایید شده</option>
            <option value="3">تایید شده</option>

          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام و نام خانوادگی</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_ProductRequest(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button *ngIf="!Procssing" routerLink="/ProductRequestForm" type="button" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه درخواست</th>
              <th>نام و نام خانوادگی</th>
              <th>تاریخ ثبت</th>
              <th>گردش کار</th>
              <th>وضیعت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of DataList_ProductRequest
                  |filter:Filter_title:'fullname'
                  | paginate
                          : {
                              id: 'DataList_FeildTable',
                              itemsPerPage: 50,
                              currentPage: page,
                              totalItems: (DataList_ProductRequest|filter:Filter_title:'fullname').length
                            }">

              <tr>
                <td rowspan="2">{{DataList_ProductRequest.indexOf(item)+1}}</td>
                <td>{{item.id}}</td>
                <td>{{item.fullname}}</td>
                
                <td>{{item.persianDate}}</td>
                <td>{{item.flowchart.flochart_title}}</td>
                <td>
                  <p *ngIf="item.status==1" style="color: rgb(20, 77, 220);">در حال بررسی</p>
                  <p *ngIf="item.status==2" style="color: #489b39;">تایید</p>
                  <p *ngIf="item.status==3" style="color: crimson;">عدم تایید</p>
                </td>

                <td rowspan="2">
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" (click)="ReadData_Form(item)" class="dropdown-item"><i class="fa fa-eye"></i> مشاهده
                        </a>
                        <a *ngIf="item.status==2" style="cursor: pointer;" (click)="ReadData_View(item)" class="dropdown-item"><i class="fa fa-leanpub"></i> بازنگری
                        </a>
                        <a href="{{BaseUrl1}}{{item.flowchart.flochart_id}}{{BaseUrlCo}}{{item.flowchart.makerId}}"  target="_blank" class="dropdown-item"><i
                            class="fa fa-wpbeginner"></i>
                          گردش کار
                        </a>
                        <a style="cursor: pointer;" (click)="ReadData_History(item)" class="dropdown-item"><i class="fa fa-history"></i>
                        تاریخچه گردش کار
                        </a>

                        <a style="cursor: pointer;" *ngIf="!item.visible" (click)="Change_visible(item)" class="dropdown-item"><i class="fa fa-eye"></i>
                          نمایش فاکتور
                        </a>

                        <a style="cursor: pointer;" *ngIf="item.visible" (click)="Change_visible(item)" class="dropdown-item"><i class="fa fa-eye-slash"></i>
                          عدم نمایش فاکتور
                        </a>


                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>توضیحات</th>
                <td colspan="4">{{item.dsc}}</td>
              </tr>

              <tr *ngIf="item.visible">
                <td  colspan="10">
                  <div class="table-responsive">
                    <table class="mb-0 table table-bordered table-3 text-center table-striped">
                      <thead style="background-color: #394b9b; color: white;">
                        <tr>
                          <th>#</th>
                          <th>نام کالا</th>
                          <th>تعداد</th>
                          <th>قیمت تقریبی (ريال)</th>
                          <th>جمع (ريال)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let itemProduct of item.detail">
                         <td>{{item.detail.indexOf(itemProduct)+1}}</td>
                          <td>{{itemProduct.title}}</td>
                          <td>{{itemProduct.amount}}</td>
                          <td>{{itemProduct.price|number}}</td>
                          <td>{{(itemProduct.price*itemProduct.amount)|number}}</td>
                        </tr>
                        <tr>
                          <td colspan="2">جمع کل</td>
                          <td colspan="4">{{item.totalPrice|number}}</td>
                        </tr>
                      </tbody>
                    </table>
                 </div> 
                </td>
              </tr>


            </ng-container>

          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<div class="col-md-12 mb-30" *ngIf="Selected_ProductRequest_Record.id>0 && FormTypeShow=='Form'">
  <app-ProductRequestView
    [inner_ProductRequest_id]="Selected_ProductRequest_Record.id">
    
  </app-ProductRequestView>

  <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
  </button>
</div>

<div class="col-md-12 mb-30" *ngIf="Selected_ProductRequest_Record.id>0 && FormTypeShow=='View'">
  <app-ProductRequestReviewForm
    [inner_request_id]="Selected_ProductRequest_Record.id">
    
  </app-ProductRequestReviewForm>

  <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
  </button>
</div>

<div *ngIf="Selected_ProductRequest_Record.id>0 && FormTypeShow=='History'" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">تاریخچه گردش درخواست '{{Selected_ProductRequest_Record.flowchart.uniCode}}' </h5>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-FlowchartHistory [DataList_History]="DataList_History"></app-FlowchartHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button" (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>حدف آخرین ارجاع</button>
        </div>


      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
    </button>
  </div>
  
</div>
